// Every controller fire ships, registered in one line per host.
//
//   import { registerFire } from '@fire';
//   registerFire(application);
//
// Four exports, not one, because three of these groups need an npm package in
// the HOST's package.json — the gem cannot vendor a JS dependency, so a host
// that calls a group it has no dep for fails at build time, loudly:
//
//   registerFire        nothing beyond @hotwired/stimulus — every host
//   registerFireInputs  imask                             — kio qir zaz
//   registerFireBridge  @hotwired/hotwire-native-bridge   — kio qir zaz
//   registerFireEditor  @milkdown/crepe                   — qir
//
// The names are the ones the hosts already used, `bridge--qrscanner` and all,
// so this changes no markup.
//
// Everything imported here lands in the bundle whether the host draws it or
// not — that is what buys the one line. The core group is ~40 KB unminified
// across fifteen files; if that ever matters more than the uniformity, a host
// can go back to importing the two or three it wants by hand.
import HqRailController from './hq_rail_controller';
import AgoController from './ago_controller';
import CardFormController from './card_form_controller';
import CepController from './cep_controller';
import DateInputController from './date_input_controller';
import DialogController from './dialog_controller';
import DockController from './dock_controller';
import DocInputController from './doc_input_controller';
import DropdownController from './dropdown_controller';
import ErrorLinksController from './error_links_controller';
import FabController from './fab_controller';
import FlashController from './flash_controller';
import AutocopyController from './autocopy_controller';
import AutosubmitController from './autosubmit_controller';
import ClipboardController from './clipboard_controller';
import LocalesController from './locales_controller';
import LocatorController from './locator_controller';
import MarkdownController from './markdown_controller';
import MultiselectController from './multiselect_controller';
import NestedController from './nested_controller';
import NudgeController from './nudge_controller';
import PasskeyController from './passkey_controller';
import PasswordRevealController from './password_reveal_controller';
import PrefillController from './prefill_controller';
import PrinterController from './printer_controller';
import PushController from './push_controller';
import ShareController from './share_controller';
import SignalLandingController from './signal_landing_controller';
import ThemeController from './theme_controller';
import TypeaheadController from './typeahead_controller';
import TvController from './tv_controller';
import TvsController from './tvs_controller';
import UploadController from './upload_controller';

const CORE = {
  ago: AgoController,
  'hq-rail': HqRailController,
  'card-form': CardFormController,
  cep: CepController,
  'date-input': DateInputController,
  dialog: DialogController,
  dock: DockController,
  'doc-input': DocInputController,
  dropdown: DropdownController,
  'error-links': ErrorLinksController,
  fab: FabController,
  flash: FlashController,
  autocopy: AutocopyController,
  autosubmit: AutosubmitController,
  clipboard: ClipboardController,
  locales: LocalesController,
  locator: LocatorController,
  markdown: MarkdownController,
  multiselect: MultiselectController,
  nested: NestedController,
  nudge: NudgeController,
  passkey: PasskeyController,
  'password-reveal': PasswordRevealController,
  prefill: PrefillController,
  printer: PrinterController,
  push: PushController,
  share: ShareController,
  'signal-landing': SignalLandingController,
  theme: ThemeController,
  typeahead: TypeaheadController,
  tv: TvController,
  tvs: TvsController,
  upload: UploadController,
};

const register = (application, map) =>
  Object.entries(map).forEach(([name, controller]) => application.register(name, controller));

export function registerFire(application) {
  register(application, CORE);
}
